import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TD from "../Images/TD.png";
import smartWorld from "../Images/smart_world.png";
import explore from "../Images/explore.png";
import AE from "../Images/AE-01.jpg";
import FF from "../Images/FF.jpg";
import n9 from "../Images/N9.jpg";
import nxt from "../Images/NXT.jpg";
import sc from "../Images/SC.jpg";

const partners = [
  {
    name: "TOM & DARIN",
    image: TD,
    pdf: "https://drive.google.com/file/d/1VvoJjm0MOaCWSosyyMBwWcR4Abanykdo/view?usp=sharing",
  },
  {
    name: "SMART WORLD",
    image: smartWorld,
    pdf: "https://drive.google.com/file/d/1eMCzKN_kDXhCqm8i6O4Ay-3cT0ja5VYu/view?usp=sharing",
  },
  // {
  //   name: "EXPLORE",
  //   image: explore,
  //   pdf: "https://drive.google.com/file/d/1SOjADeI4R7MPvcQFqHsZhstV1UrkF_k9/view?usp=sharing",
  // },
  {
    name: "Al EMAAR",
    image: AE,
    pdf: "",
  },
  {
    name: "FRESHIFY",
    image: FF,
    pdf: "https://drive.google.com/file/d/1SOjADeI4R7MPvcQFqHsZhstV1UrkF_k9/view?usp=sharing",
  },
  {
    name: "SCENT CRAFT",
    image: sc,
    pdf: "https://drive.google.com/file/d/1SOjADeI4R7MPvcQFqHsZhstV1UrkF_k9/view?usp=sharing",
  },
  {
    name: "NO9",
    image: n9,
    pdf: "https://drive.google.com/file/d/1SOjADeI4R7MPvcQFqHsZhstV1UrkF_k9/view?usp=sharing",
  },
  {
    name: "NXT",
    image: nxt,
    pdf: "https://drive.google.com/file/d/1SOjADeI4R7MPvcQFqHsZhstV1UrkF_k9/view?usp=sharing",
  },
];

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 800,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
};

const OurPartners = () => {
  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-8">
          Brands
        </h2>
        <Slider {...sliderSettings}>
          {partners.map((partner, index) => (
            <div key={index} className="px-2">
              <div className="bg-gray-50 hover:bg-gray-100 transition rounded-lg p-4 flex flex-col items-center shadow-sm">
                <a
                  key={index}
                  href={partner.pdf} // Link to the PDF file
                  target="_blank" // Open in a new tab
                  rel="noopener noreferrer" // For security
                  className="bg-white shadow-md rounded-lg p-4 flex flex-col items-center hover:scale-105 transition-transform"
                >
                  <img
                    src={partner.image}
                    alt={partner.name}
                    className="h-32 w-32 object-cover rounded-full"
                  />
                  <h3 className="text-lg font-semibold mt-4 text-center">
                    {partner.name}
                  </h3>
                </a>
                {/* <p className="text-sm font-medium text-gray-700">
                  {partner.name}
                </p> */}
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default OurPartners;
